class PriceAlert {
  constructor() {}

  static add = (_product_id, _email = null) => {
    let request = new window.fetchdata();
    let url = `${window.origin}/service/price-alerts/add`;
    let data = { product_id: _product_id, email: _email };
    request.fetchData(
      url,
      "post",
      JSON.stringify(data),
      (response) => {},
      (response) => {
        console.log("correu um erro ");
      },
    );
  };
}

window.PriceAlert = PriceAlert;
